export default "__VITE_ASSET__d5f8be3c__"